import { getSessionToken, signOut } from './auth';

const API_URL = (import.meta.env.VITE_PROSPECTOR_API_URL as string | undefined)?.replace(/\/$/, '');
export const isDemo = !API_URL;
export async function api<T>(path: string, init: RequestInit = {}): Promise<T> {
  if (!API_URL) throw new Error('API is not configured');
  let token: string;
  try { token = await getSessionToken(); }
  catch (error) { signOut(); window.location.assign('/'); throw error; }
  const response = await fetch(`${API_URL}${path}`, { ...init, headers: { 'content-type': 'application/json', authorization: `Bearer ${token}`, ...init.headers } });
  if (response.status === 401 || response.status === 403) { signOut(); window.location.assign('/'); throw new Error('Your session has expired. Please sign in again.'); }
  const body = await response.json(); if (!response.ok) throw new Error(body.error ?? 'Request failed'); return body.data as T;
}
